// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/image-picker/style/index.less
// module id = 160
// module chunks = 0